import { render, staticRenderFns } from "./StoreLocatorFilter.vue?vue&type=template&id=5c23139c&scoped=true&"
import script from "./StoreLocatorFilter.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorFilter.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorFilter.vue?vue&type=style&index=0&id=5c23139c&prod&lang=less&scoped=true&"
import style1 from "./StoreLocatorFilter.vue?vue&type=style&index=1&id=5c23139c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23139c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
